import type { CSSProperties } from 'react'

import { EvnttzIcon } from '@/shared/ui/EvnttzIcons'
import { resolveEvnttzIconName } from '@/shared/ui/EvnttzIcons/catalog'

import type { ModuleIconName } from './icons'

export type { ModuleIconName }

interface ModuleIconProps {
  name: ModuleIconName | string
  size?: number
  className?: string
  style?: CSSProperties
}

export const ModuleIcon = ({ name, size = 32, className, style }: ModuleIconProps) => {
  const canonical = resolveEvnttzIconName(name)

  return <EvnttzIcon name={canonical} size={size} className={className} style={style} />
}

const MIN_NAV_SIZE = 38

// Drop-in factory for ModuleNavItem.icon slots — ignores HugeIcon-specific props.
// Enforces minimum 32px so 3D illustrated icons remain legible in nav surfaces.
export const createModuleIcon = (name: ModuleIconName | string) => {
  const Wrapper = ({ size = MIN_NAV_SIZE, className }: { size?: number; className?: string; [key: string]: unknown }) => (
    <ModuleIcon name={name} size={Math.max(size, MIN_NAV_SIZE)} className={className} />
  )
  Wrapper.displayName = `ModuleIcon(${name})`
  return Wrapper
}
